/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * 활성 단가 수 · 포함가로 라벨된 수 · 과세 여부를 모르는 품목 수 · 확인 도장.
 * @summary 업체 단가의 축 상태 (마스터)
 */
export const adminPriceAxisControllerGetStatusParams = zod
  .object({
    supplierId: zod.coerce.string(),
  })
  .strict();

export const adminPriceAxisControllerGetStatusResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        supplierId: zod.string(),
        supplierName: zod.string().nullish(),
        priceCount: zod.number().describe("활성 단가 수"),
        inclusiveCount: zod.number().describe("그중 부가세 포함가로 라벨된 수"),
        unknownTaxCategoryCount: zod
          .number()
          .describe("과세/면세를 모르는 품목 수"),
        verifiedAt: zod
          .string()
          .nullish()
          .describe(
            "축을 확인한 시각. 비어 있으면 몰이 이 업체 단가를 환산하지 않는다",
          ),
        note: zod.string().nullish(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 값은 그대로 두고 축만 바꾼다. dryRun 이 기본이며, 실행하면 되돌릴 수 있다. 전 품목을 대상으로 할 때만 «확인됨» 도장이 찍히고, 그 도장이 있어야 몰이 환산한다.
 * @summary 업체 단가의 축 일괄 정정 (마스터)
 */
export const adminPriceAxisControllerSetSupplierAxisParams = zod
  .object({
    supplierId: zod.coerce.string(),
  })
  .strict();

export const adminPriceAxisControllerSetSupplierAxisBodyMarkVerifiedDefault = true;
export const adminPriceAxisControllerSetSupplierAxisBodyDryRunDefault = true;

export const adminPriceAxisControllerSetSupplierAxisBody = zod
  .object({
    taxType: zod
      .enum(["EXCLUSIVE", "INCLUSIVE"])
      .describe(
        "EXCLUSIVE=이 업체 단가는 공급가액 / INCLUSIVE=부가세 포함가. 값은 그대로 두고 축만 바꾼다",
      ),
    itemIds: zod
      .array(zod.string())
      .optional()
      .describe("일부 품목만 정정할 때. 비우면 이 업체의 활성 단가 전부"),
    markVerified: zod
      .boolean()
      .default(adminPriceAxisControllerSetSupplierAxisBodyMarkVerifiedDefault)
      .describe(
        "축이 사실과 맞는지 확인했다는 도장. 이걸 찍어야 몰이 이 업체 단가를 환산한다. 일부 품목만 정정할 때는 찍히지 않는다 — 나머지 미확인분까지 환산 대상이 되기 때문이다",
      ),
    note: zod
      .string()
      .optional()
      .describe(
        "무엇으로 확인했는지(원본 파일 헤더·업체 회신·세금계산서 대조 등). 나중에 «왜 이렇게 정했나» 에 답하는 유일한 근거다",
      ),
    dryRun: zod
      .boolean()
      .default(adminPriceAxisControllerSetSupplierAxisBodyDryRunDefault),
  })
  .strict();

export const adminPriceAxisControllerSetSupplierAxisResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        dryRun: zod.boolean(),
        taxType: zod.enum(["EXCLUSIVE", "INCLUSIVE"]),
        targets: zod.number().describe("이 업체의 활성 단가 수"),
        willChange: zod.number().describe("축이 바뀔(바뀐) 행 수"),
        changed: zod.number().describe("실제로 바뀐 행 수(dryRun 이면 0)"),
        unknownTaxCategory: zod
          .number()
          .describe(
            "과세/면세를 모르는 품목 수. 이 품목들은 도장을 찍어도 환산하지 않는다 — 면세를 과세로 단정하면 가격이 조용히 9% 떨어진다",
          ),
        vatFree: zod
          .number()
          .describe("면세·영세 품목 수(축과 무관하게 값이 그대로다)"),
        samples: zod
          .array(
            zod
              .object({
                name: zod.string(),
                basePrice: zod
                  .number()
                  .describe("지금 저장돼 있는 값(안 바뀐다)"),
                supplyPrice: zod
                  .number()
                  .describe("정정 후 이 단가가 뜻하게 되는 공급가액"),
                totalPrice: zod
                  .number()
                  .describe("정정 후 부가세까지 더한 총액"),
                taxCategory: zod
                  .enum(["TAXABLE", "EXEMPT", "ZERO_RATED"])
                  .nullish()
                  .describe("면세·영세면 공급가액과 총액이 같다"),
              })
              .strict(),
          )
          .describe("고가 순 최대 20건"),
        batchId: zod.string().nullish(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 면세·영세 품목은 공급가액과 총액이 같아 축 환산을 하지 않는다. 이 값이 비어 있으면 그 품목은 축을 확인해도 환산 대상에서 빠진다.
 * @summary 품목의 과세/면세 일괄 지정 (마스터)
 */
export const adminPriceAxisControllerSetTaxCategoryBodyOnlyUnsetDefault = true;
export const adminPriceAxisControllerSetTaxCategoryBodyDryRunDefault = true;

export const adminPriceAxisControllerSetTaxCategoryBody = zod
  .object({
    taxCategory: zod
      .enum(["TAXABLE", "EXEMPT", "ZERO_RATED"])
      .describe("TAXABLE=과세 / EXEMPT=면세 / ZERO_RATED=영세율"),
    itemIds: zod.array(zod.string()).optional(),
    supplierId: zod
      .string()
      .optional()
      .describe("이 업체가 취급하는 품목 전부를 대상으로 할 때"),
    onlyUnset: zod
      .boolean()
      .default(adminPriceAxisControllerSetTaxCategoryBodyOnlyUnsetDefault)
      .describe(
        "비어 있는 것만 채운다. 품목은 업체 사이에 공유되므로, 이미 지정된 값을 덮으면 남이 확인해 둔 사실까지 지워진다",
      ),
    dryRun: zod
      .boolean()
      .default(adminPriceAxisControllerSetTaxCategoryBodyDryRunDefault),
  })
  .strict();

export const adminPriceAxisControllerSetTaxCategoryResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        dryRun: zod.boolean(),
        taxCategory: zod.enum(["TAXABLE", "EXEMPT", "ZERO_RATED"]),
        targets: zod.number(),
        willChange: zod.number(),
        changed: zod.number(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 축 정정 이력 (마스터)
 */
export const adminPriceAxisControllerListBatchesQueryParams = zod
  .object({
    supplierId: zod.coerce.string().optional(),
    limit: zod.unknown().optional(),
  })
  .strict();

export const adminPriceAxisControllerListBatchesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string(),
            supplierId: zod.string(),
            supplierName: zod.string().nullish(),
            taxType: zod.enum(["EXCLUSIVE", "INCLUSIVE"]),
            previousTaxType: zod.enum(["EXCLUSIVE", "INCLUSIVE"]),
            affected: zod.number(),
            markedVerified: zod
              .boolean()
              .describe("이 정정으로 «확인됨» 도장이 찍혔는지"),
            note: zod.string().nullish(),
            undoneAt: zod.string().nullish(),
            undoneCount: zod.number().nullish(),
            createdAt: zod.string(),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 그 배치가 바꾼 행을 이전 축으로 되돌리고 확인 도장도 함께 뗀다.
 * @summary 축 정정 되돌리기 (마스터)
 */
export const adminPriceAxisControllerUndoBatchParams = zod
  .object({
    batchId: zod.coerce.string(),
  })
  .strict();

export const adminPriceAxisControllerUndoBatchResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        batchId: zod.string(),
        undone: zod.number(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
